import SectionHeading from "@/components/feature/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import { works } from "@/mocks/works";

export default function LatestWorks() {
  const latest = [...works].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Latest"
        title="最新投稿作品"
        desc="刚刚通过审核的参赛投稿，题材跨度很大，适合一页一页往下翻。"
        linkTo="/works?sort=latest"
        linkLabel="查看更多投稿"
      />
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {latest.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}